import React from 'react'
import prefetchCmsPage from 'graphql/prefetchers/prefetchCmsPage'
import { initializeApollo } from 'lib/apolloClient'
import { setCacheControlHeader } from 'lib/cache'
import { useTranslation } from 'lib/i18n'
import { isServer } from 'lib/utils'
import { NextPageContext } from 'next'
import { NextSeo } from 'next-seo'

import BlogPage from 'components/BlogPage/BlogPage'
import PublicLayout from 'components/PublicLayout/PublicLayout'
import useIsDefaultLanguage from 'hooks/useIsDefaultLanguage'

function Seo() {
  const { t } = useTranslation()
  const isDefaultLanguage = useIsDefaultLanguage()

  const meta = {
    title: t('blog.meta.title', 'Blog - memmo'),
    description: t(
      'blog.meta.description',
      'Keep up to date with memmo! Read about profile updates and more in our blog',
    ),
  }

  return (
    <NextSeo
      title={meta.title}
      description={meta.description}
      openGraph={meta}
      noindex={!isDefaultLanguage}
      nofollow={!isDefaultLanguage}
    />
  )
}

function BlogListPage(): JSX.Element {
  return (
    <PublicLayout bottom={false}>
      <Seo />
      <BlogPage />
    </PublicLayout>
  )
}

BlogListPage.getInitialProps = async (ctx: NextPageContext) => {
  if (isServer()) {
    setCacheControlHeader({ ctx, ttl: 300 })
    const apolloClient = initializeApollo(ctx)
    await prefetchCmsPage(apolloClient, { slug: 'blog' })

    return {
      initialApolloState: apolloClient.cache.extract(),
    }
  }

  return {}
}

export default BlogListPage
